import { render, staticRenderFns } from "./PublicTestimonialList.vue?vue&type=template&id=73b321bf&"
import script from "./PublicTestimonialList.vue?vue&type=script&lang=js&"
export * from "./PublicTestimonialList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports